<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur  border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div>
  <br><br><br><br><br>
  <main class="mt-0 main-content">
    <section>
    
    <div class="py-4 container-fluid">

      <div class="row">

        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
              <div class="date-range-buttons">
                <button id="filter_all" :class="{ active: selectedAgency === 'all' }" @click="showCustomDates = false; apply_filter(selectedAgency, 'all', start_date, end_date, selectedDateType)">All</button>
                <button id="filter_today" :class="{ active: selectedFilter === 'today' }" @click="showCustomDates = false; apply_filter(selectedAgency, 'today', start_date, end_date, selectedDateType)">Today</button>
                <button id="filter_yesterday" :class="{ active: selectedFilter === 'yesterday' }" @click="showCustomDates = false; apply_filter(selectedAgency, 'yesterday', start_date, end_date, selectedDateType)">Yesterday</button>
                <button id="filter_last_7_days" :class="{ active: selectedFilter === 'last_7_days' }" @click="showCustomDates = false; apply_filter(selectedAgency, 'last_7_days', start_date, end_date, selectedDateType)">Last 7 Days</button>
                <button id="filter_last_30_days" :class="{ active: selectedFilter === 'last_30_days' }" @click="showCustomDates = false; apply_filter(selectedAgency, 'last_30_days', start_date, end_date, selectedDateType)">Last 30 Days</button>
                <button id="filter_last_90_days" :class="{ active: selectedFilter === 'last_90_days' }" @click="showCustomDates = false; apply_filter(selectedAgency, 'last_90_days', start_date, end_date, selectedDateType)">Last 90 Days</button>
                <button id="filter_365_days" :class="{ active: selectedFilter === 'last_365_days' }" @click="showCustomDates = false; apply_filter(selectedAgency, 'last_365_days', start_date, end_date, selectedDateType)">Last 365 Days</button>
                <button id="filter_custom" :class="{ active: selectedFilter === 'custom' }" @click="custom_filter">Custom Date range</button>
              </div>

              <br>

              <div class="date-range-buttons">
                
                <span v-if="isFYMAdmin" class="td1 heading">
                  <select id="agency_select" class="form-select" v-model="selectedAgency" @change="apply_filter(selectedAgency, selectedFilter, start_date, end_date, selectedDateType)">
                    <option value="0" selected>All</option>
                    <option value="1">FYM</option>
                    <option value="3">Oasis</option>
                    <option value="4">Collins</option>
                    <option value="5">Medcora</option>
                    <option value="6">Wise Choice</option>
                    <option value="7">Aspire</option>
                    <option value="8">HIP</option>
                    <option value="9">Csipkes</option>
                    <option value="10">PBG</option>
                  </select>
                </span>
                
                <span>
                  <select id="date_type" class="form-select td2" v-model="selectedDateType" @change="apply_filter(selectedAgency, selectedFilter, start_date, end_date, selectedDateType)">
                    <option value="1" selected>Submit Date</option>
                    <option value="2">Effective Date</option>
                  </select>
                </span>

                <input v-if="showCustomDates" class="form-control td2" id="start_date" name="start_date" type="date" v-model="start_date"/>&nbsp;
                <input v-if="showCustomDates" class="form-control td2" id="end_date" name="end_date" type="date" v-model="end_date"/>&nbsp;
                <button v-if="showCustomDates" id="apply_custom_filter" @click="apply_filter(selectedAgency,'custom', start_date, end_date, selectedDateType)">Apply filter</button>
              </div>
              <br>
            </div>
          </div>
        </div>
        <br><br>
        <div class="col-lg-12">
          <div class="row">
            <div class="col-lg-2 col-md-6 col-12">
              <card
                title="Total Enrollments"
                :value="metrics[0].total_enrollments"
                percentage=""
                iconClass=""
                iconBackground=""
                detail=""
                directionReverse
              ></card>
            </div>
            <div class="col-lg-2 col-md-6 col-12">
              <card
                title="MAPD"
                :value="metrics[0].mapd"
                percentage=""
                iconClass=""
                iconBackground=""
                detail=""
                directionReverse
              ></card>
            </div>
            <div class="col-lg-2 col-md-6 col-12">
              <card
                title="MA"
                :value="metrics[0].ma"
                percentage=""
                iconClass=""
                iconBackground=""
                percentageColor=""
                detail=""
                directionReverse
              ></card>
            </div>
            <div class="col-lg-2 col-md-6 col-12">
              <card
                title="PDP"
                :value="metrics[0].pdp"
                percentage=""
                iconClass=""
                iconBackground=""
                hint=""
                directionReverse
              ></card>
            </div>
            <div class="col-lg-2 col-md-6 col-12">
              <card
                title="CSNP"
                :value="metrics[0].csnp"
                percentage=""
                iconClass=""
                iconBackground=""
                hint=""
                directionReverse
              ></card>
            </div>
            <div class="col-lg-2 col-md-6 col-12">
              <card
                title="DSNP"
                :value="metrics[0].dsnp"
                percentage=""
                iconClass=""
                iconBackground=""
                hint=""
                directionReverse
              ></card>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-lg-12 mb-lg-0 mb-4">
              <div class="card">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Enrollments by Agent</h6>
                  </div>
                </div>
                <div class="table-responsive">
                  <ul>
                    <div v-if="enrollments_by_agent.length">
                      <h1>Total: {{ enrollments_by_agent[0].total }}</h1>
                    </div>
                    <li v-for="(item, index) in enrollments_by_agent" :key="index" class="inline-item">
                      {{ item.agent }} <h2>{{ item.enrollments }}</h2> <h3>{{ item.percentage }}%</h3>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <ColorBarChart />
            </div>

          </div>

          <div class="row mt-4">
            <div class="col-lg-12 mb-lg-0 mb-4">
              <div class="card">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Carrier Breakdown</h6>
                  </div>
                </div>
                <div class="table-responsive">
                  <ul>

                    <div v-if="enrollments_by_carrier.length">
                      <h1>Total: {{ enrollments_by_carrier[0].total }}</h1>
                    </div>

                    <li v-for="(item, index) in enrollments_by_carrier" :key="index" class="inline-item">
                      {{ item.carrier }} <h2>{{ item.enrollments }}</h2> <h3>{{ item.percentage }}%</h3>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
            </div>

          </div>

          <div class="row mt-4">
            <div class="col-lg-12 mb-lg-0 mb-4">
              <div class="card">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Enrollments by State</h6>
                  </div>
                </div>
                <div class="table-responsive">
                  <ul>

                    <div v-if="enrollments_by_state.length">
                      <h1>Total: {{ enrollments_by_state[0].total }}</h1>
                    </div>

                    <li v-for="(item, index) in enrollments_by_state" :key="index" class="inline-item">
                      {{ item.state }} <h2>{{ item.enrollments }}</h2> <h3>{{ item.percentage }}%</h3>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
            </div>

          </div>

          <div v-if="isFYMAdmin" class="row mt-4">
            <div class="col-lg-4 mb-lg-0 mb-4">
              <div class="card">
                <div class="p-3 pb-0 card-header">
                  <div class="d-flex justify-content-between">
                    <h6 class="mb-2">Enrollments by Agency</h6>
                  </div>
                </div>
                <div class="table-responsive">
                  <chart-card :key="pieChartKey" :chart-data="pieChart.data" chart-type="Pie">                    
                  </chart-card>

                  <ul>

                    <div v-if="enrollments_by_agency.length">
                      <h1>Total: {{ enrollments_by_agency[0].total }}</h1>
                    </div>

                    <li v-for="(item, index) in enrollments_by_agency" :key="index" class="inline-item">
                      {{ item.agency }} <h2>{{ item.enrollments }}</h2> <h3>{{ item.percentage }}%</h3>
                    </li>
                  </ul>

                </div>
              </div>
            </div>

            <div class="col-lg-6">
            </div>

          </div>

        </div>
      </div>
    </div>

    </section>
  </main>

</template>

<script>

import { ref } from 'vue';

import Navbar from "@/examples/PageLayout/NavbarLoggedin.vue";

import Card from "@/examples/Cards/Card.vue";
import ChartCard from "@/examples/Cards/ChartCard.vue";
import StatsCard from "@/examples/Cards/StatsCard.vue";
import ColorBarChart from "@/examples/Charts/ColorBarChart.vue";

const company = sessionStorage.getItem("company");
const showCustomDates = ref(false);

var today = String(new Date().getFullYear()) + '-' + String(new Date().getMonth() + 1) + '-' + String(new Date().getDay());

export default {
  name: "dashboard",
  data() {
    return {
      selectedAgency: 0,
      selectedDateType: 1,
      selectedFilter: 'last_7_days', // default selected
      start_date: '2025-04-24',
      end_date: '2025-04-24',
      metrics: [{ 
        'total_enrollments': 0,
        'mapd': 0,
        'ma': 0,
        'pdp': 0,
        'csnp': 0,
        'dsnp': 0
    }],
    pieChartKey: 0, // force re-rendering key
    enrollments_by_agency: [],
    enrollments_by_carrier: [],
    enrollments_by_state: [],
    enrollments_by_agent: [],
    pieChart: {
      data: {
        labels: [],
        series: []
      }
    },
    company: '',
    sales: [],
    sales_today: [],
    sales_aep: [],
    aep_total: 0,
    todays_totals: 0,
    onboarding: [{ 
        'Contracting': 0,
        'Contracting_age': 0,
        'Operations': 0,
        'Operations_age': 0,
        'Training': 0,
        'Training_age': 0,
        'Compliance': 0,
        'Compliance_age': 0,
        'Agency': 0,
        'Agency_age': 0,
        'RTS': 0,
        'RTS_age': 0
    }],
    role: sessionStorage.getItem('role')
    };
  },
  computed: {
    isFYMAdmin() {
      return this.role === 'FYM Admin';
    },
    isAgencyAdmin() {
      return this.role === 'Agency Admin';
    },
    isAgentManager() {
      return this.role === 'Agent Manager';
    },
    isAgent() {
      return this.role === 'Agent';
    }
  },
  methods: {
    async custom_filter() {
      this.selectedFilter = 'custom'; 
      this.showCustomDates = true;
    },
    async apply_filter(agency_id, filter, start_date, end_date, selected_date_type) {
      this.selectedFilter = filter; // set active button

      let response1 = await fetch("/apis/enrollment_metrics/" + agency_id + '/' + filter + '/' + start_date + '/' + end_date + '/' + selected_date_type);
      this.metrics = await response1.json();

      let response_carrier = await fetch("/apis/enrollments_by_carrier/" + agency_id + '/' + filter + '/' + start_date + '/' + end_date + '/' + selected_date_type);
      this.enrollments_by_carrier = await response_carrier.json();

      let response_state = await fetch("/apis/enrollments_by_state/" + agency_id + '/' + filter + '/' + start_date + '/' + end_date + '/' + selected_date_type);
      this.enrollments_by_state = await response_state.json();

      let response_agent = await fetch("/apis/enrollments_by_agent/" + agency_id + '/' + filter + '/' + start_date + '/' + end_date + '/' + selected_date_type);
      this.enrollments_by_agent = await response_agent.json();

      if(this.isFYMAdmin) {
        let response_agency = await fetch("/apis/enrollments_by_agency/" + filter + '/' + start_date + '/' + end_date + '/' + selected_date_type);
        this.enrollments_by_agency = await response_agency.json();

        this.pieChart = {
          data: {
            labels: this.enrollments_by_agency.map(item => item.agency),
            series: this.enrollments_by_agency.map(item => parseFloat(item.percentage))
          }
        };

      this.pieChartKey++; // increment key to force re-render

      }
    },
  },
  components: {
    Navbar,
    Card,
    StatsCard,
    ChartCard,
    ColorBarChart
  },
  created() {
    this.company = sessionStorage.getItem("company");
    this.apply_filter(0, 'last_7_days', this.start_date, this.end_date, 1);
  },
};
</script>
